import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const EntitlementListStyles: moduleStyleType = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflow: 'auto',
    },
    subtitle: {
        marginBottom: 2,
    },
}
